<!--
 * @Author: wyq
 * @Date: 2021-08-31 15:14:51
 * @LastEditTime: 2021-10-21 16:13:54
 * @LastEditors: wyq
 * @Description: 
 * @FilePath: \question_bank_console\src\components\edit\progressLabel.vue
-->
<template>
  <div class="knowledge-graph">
    <el-button type="primary" @click="showDialog">选择</el-button>
    <span v-for="item in confirmNodes" :key="item.id" class="knowledge-tag">{{ item.label }}</span>
    <el-dialog
      title="添加标签"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :modal-append-to-body="false"
    >
      <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini"></el-input>
      <el-scrollbar style="height:400px">
        <el-tree
          ref="tree"
          :data="treeData"
          node-key="id"
          default-expand-all
          show-checkbox
          :filter-node-method="filterNode"
        ></el-tree>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    grade: Number,
    subject: Number,
    labels: Array,
  },
  data() {
    return {
      dialogVisible: false,
      // treeData: [],
      filterText: '',
      confirmNodes: [],
      confirmKey: [],
    }
  },
  computed: {
    treeData() {
      return this.grade == 1 ? this.$store.state.progressTree1 : this.$store.state.progressTree2
    },
  },
  watch: {
    labels: {
      handler(val) {
        console.log(val)
        this.confirmKey = val
        this.confirmNodes = val.map((i) =>
          this.treeData.find((tree) => tree.id == i)
        )
      },
      immediate: true,
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    dialogVisible(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys(this.confirmKey, true)
        }, 500)
      }
    },
  },
  methods: {
    handleClose() {
      this.$refs.tree.setCheckedKeys([])
      this.dialogVisible = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    showDialog() {
      this.dialogVisible = true
    },
    submit() {
      this.confirmNodes = this.$refs.tree.getCheckedNodes()
      this.confirmKey = this.$refs.tree.getCheckedKeys()
      console.log(this.confirmNodes, this.confirmKey)
      this.$emit('update:labels', this.confirmKey)
      this.dialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.knowledge-graph {
  .el-button {
    margin-bottom: 8px;
    margin-right: 10px;
  }
  .knowledge-tag {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    max-width: 100%;
    margin-right: 8px;
    margin-bottom: 8px;
    background-color: #f7f7f7;
    color: #666666;
    border-radius: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    vertical-align: middle;
  }
  .el-tree {
    margin: 20px 0;
  }
}
</style>